import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { IZonaCiudad, IZonaCiudadResponse } from './interfaces/zona-ciudad.interface';
import { ZonaCiudadService } from './services/zona-ciudad.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-zona-ciudades',
  templateUrl: './zona-ciudades.component.html',
  providers: [MessageService]
})
export class ZonaCiudadesComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedZonaCiudad: IZonaCiudad | null = null;
  dataSource: IZonaCiudad[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'zona', header: 'Clave Zona', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private zonaCiudadService: ZonaCiudadService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.zonaCiudadService.getZonas('999').subscribe({
      next: (response: IZonaCiudadResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar las zonas/ciudades'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar las zonas/ciudades'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedZonaCiudad = null;
    this.displayDialog = true;
  }

  openUpdate(row: IZonaCiudad): void {
    this.selectedZonaCiudad = { ...row };
    this.displayDialog = true;
  }

  onDialogClosed(): void {
    this.selectedZonaCiudad = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  deleteZona(zona: any): void {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar la zona ${zona.zona}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        iconColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          this.zonaCiudadService.deleteZonaCiudad(zona.zona).subscribe({
            next: (response) => {
              if (response.success && response.data === true) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Zona eliminada correctamente'
                });
                this.loadData();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No se pudo eliminar la zona. Verifique que no tenga ciudades asociadas.'
                });
              }
            },
            error: (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar la zona'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }
} 